/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            page: null,
            url: null
        },

        /**
         * @param {Object} dto
         * @returns {ProductSampleModel}
         */
        fromDTO: function(dto) {
            this.set('page', dto.page);
            this.set('url', dto.url);

            return this;
        }
    });
});
